import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';

interface ItfItem {
    title: string;
    subtitle: string;
    desc: string;
}
const Tab1: React.FC = () => {
    const { t } = useLang('stream.overview');
    const items: ItfItem[] = [
        {
            title: t('E_item1_list1_title'),
            subtitle: t('E_item1_list1_subtitle'),
            desc: t('E_item1_list1_desc'),
        },
        {
            title: t('E_item1_list2_title'),
            subtitle: t('E_item1_list2_subtitle'),
            desc: t('E_item1_list2_desc'),
        },
        {
            title: t('E_item1_list3_title'),
            subtitle: t('E_item1_list3_subtitle'),
            desc: t('E_item1_list3_desc'),
        },
        {
            title: t('E_item1_list4_title'),
            subtitle: t('E_item1_list4_subtitle'),
            desc: t('E_item1_list4_desc'),
        },
    ];

    return (
        <div className={`${css.frag}`}>
            <EcoImg
                className="tab1-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1774594568223/e1.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1774594568223/e1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1774594568502/e1m.jpg"
                alt={t('E_item1_list1_title')}
            />
            <ul className="items">
                {items?.map((item: ItfItem, i: number) => (
                    <li className="item" key={i}>
                        <p className="item-title">{item.title}</p>
                        <p className="item-subtitle">{item.subtitle}</p>
                        <p className="item-desc">{item.desc}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Tab1;
